import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import ThemeToggle from "@/components/ThemeToggle";

const FULL_LOGO = "https://customer-assets.emergentagent.com/job_af8f5b12-cd02-481d-8aac-658ba1fd8e83/artifacts/bw9rp3yz_sb.png";
const SB_MONO = "https://customer-assets.emergentagent.com/job_af8f5b12-cd02-481d-8aac-658ba1fd8e83/artifacts/uzu8frqy_mono.png";

const LINKS = [
    { href: "#about", label: "Index", num: "01" },
    { href: "#capabilities", label: "Practice", num: "02" },
    { href: "#philosophy", label: "Tenets", num: "03" },
    { href: "#contact", label: "Contact", num: "04" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <motion.header
            initial={{ y: -16, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 1.6 }}
            className="fixed inset-x-0 top-0 z-40 px-4 sm:px-6 lg:px-10 pt-4"
            data-testid="navbar"
        >
            <div className={`mx-auto flex max-w-[1480px] items-center justify-between gap-6 rounded-2xl border-sb border px-4 py-2.5 transition-all duration-500 ${scrolled ? "glass-sb" : ""}`}>
                <a href="#hero" className="flex items-center gap-2.5 pl-1" data-testid="navbar-logo-link">
                    <img src={SB_MONO} alt="" className="h-10 w-10 rounded-md" />
                    <span className="font-serif text-[30px] leading-none text-sb tracking-tight">sysbrains</span>
                    <span aria-hidden className="ml-1 hidden sm:inline-block h-1 w-1 rounded-full bg-sb-mint" />
                </a>

                <nav className="hidden md:flex items-center gap-1">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className="group flex items-center gap-2 rounded-full px-4 py-2 text-[15px] text-sb-soft transition-colors hover:bg-sb-2"
                        >
                            <span className="font-mono text-[11px] tracking-[0.18em] text-sb-muted group-hover:text-sb-mint">{l.num}</span>
                            <span>{l.label}</span>
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-2 sm:gap-3">
                    <ThemeToggle />
                    <a
                        href="#contact"
                        data-testid="navbar-cta-button"
                        className="group relative inline-flex items-center gap-2 rounded-full bg-sb-mint pl-5 pr-2 py-2 text-sm font-medium text-[#0B1220] transition-all"
                    >
                        <span>Let's Talk</span>
                        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#0B1220] text-sb-mint transition-transform group-hover:rotate-45">
                            <svg width="11" height="11" viewBox="0 0 10 10" fill="none"><path d="M1 9L9 1M9 1H2M9 1V8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        </span>
                    </a>
                </div>
            </div>
        </motion.header>
    );
}
